<template>
  <div id="sms-overview" class="my-auto">
    <b-card
      overlay
      img-src="/img/phone-text.png"
      bg-variant="transparent"
      border-variant="0"
      style="z-index: 10; box-shadow: none"
      class="sticky-top"
      body-class="p-0"
    >
      <div id="phone-container" class="overflow-auto bg-white p-2">
        <p
          v-if="smsText && smsText.length"
          id="sms-text"
          class="p-2 bg-light mb-0"
        >{{smsText | capitalize}}</p>
      </div>

    </b-card>
  </div>

</template>

<script>
  export default {
    name: "smsTemplateOverview",
    props: {
      smsText: null
    }
  }
</script>

<style scoped>
  #phone-container {
    width: 260px;
    height: 252px;
    margin: 0 auto;
    top: 111px;
    left: 21px;
    position: absolute;
  }
#sms-overview {
  width: 300px;
  margin: 0 auto;
}
  #sms-text {
    border-radius: 10px;
    background-color: #e5e5e5;
    font-size: 14px;
  }
</style>
